import { formatFileSize, type TicketMessageAttachment } from '@easyhelp/shared';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useDownloadMessageAttachment } from '../../api/ticket-messages';

/**
 * Allegati di una risposta o di una nota nel thread (story #43): ogni file è un pulsante-link che lo
 * scarica dall'API, che registra chi scarica. Mai mostrato nella pagina, anche le immagini. Un
 * download non riuscito (archivio non disponibile, allegato non trovato) è un messaggio sotto
 * l'elenco; con la sessione scaduta si torna all'accesso.
 */
export function MessageAttachmentList({
  code,
  attachments,
}: {
  code: string;
  attachments: readonly TicketMessageAttachment[] | undefined;
}) {
  const download = useDownloadMessageAttachment(code);
  if (!attachments || attachments.length === 0) return null;
  return (
    <Stack spacing={1}>
      <Stack component="ul" spacing={0.5} aria-label="Allegati" sx={{ m: 0, p: 0, listStyle: 'none' }}>
        {attachments.map((attachment) => (
          <Stack component="li" key={attachment.id} direction="row" spacing={1} alignItems="center">
            <AttachFileIcon fontSize="small" color="action" />
            <Link
              component="button"
              type="button"
              variant="body2"
              disabled={download.isPending}
              aria-label={`Scarica ${attachment.filename}`}
              onClick={() => download.mutate(attachment)}
              sx={{ textAlign: 'left', overflowWrap: 'anywhere' }}
            >
              {attachment.filename}
            </Link>
            <Typography variant="caption" color="text.secondary">
              {formatFileSize(attachment.size)}
            </Typography>
          </Stack>
        ))}
      </Stack>
      {download.isError && download.error.status !== 401 && (
        <Alert severity="error" onClose={() => download.reset()}>
          Download di «{download.variables.filename}» non riuscito: {download.error.message}
        </Alert>
      )}
    </Stack>
  );
}
